exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box-login[data-v-0c8848a7] {\n\tpadding: 3rem;\n\twidth: 400px;\n}\n.w-100[data-v-0c8848a7] {\n\twidth: 100%;\n}\n.input-login[data-v-0c8848a7] {\n\tborder-color: transparent;\n\tcolor: #363636;\n\tborder-radius: 5px;\n}\n.input-login[data-v-0c8848a7]:focus {\n\t-webkit-box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);\n\tbox-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);\n}\n.font-12[data-v-0c8848a7] {\n\tfont-size: 12px;\n}\n", ""]);

// exports
